<div
  *ngIf="_data && _data.numPages"
  class="row-layout"
  style="align-items: center"
>
  <div style="margin-right: 0.5rem">Seiten</div>
  <button
    mat-icon-button
    (click)="loadPrevPage()"
    *ngIf="hasPrevPage"
    class="doc-nav-btn"
  >
    <mat-icon class="doc-nav-btn-icon">chevron_left</mat-icon>
  </button>
  <div>{{ currentPageIdx + 1 }} / {{ _data.numPages }}</div>
  <button
    mat-icon-button
    class="doc-nav-btn"
    (click)="loadNextPage()"
    *ngIf="hasNextPage"
  >
    <mat-icon class="doc-nav-btn-icon">chevron_right</mat-icon>
  </button>
</div>
